import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingTelegram from "@/components/marketing/FloatingTelegram";

export default function MarketingLayout() {
  return (
    <div className="min-h-screen relative overflow-hidden" style={{ background: "linear-gradient(180deg, #f6f6f8, #f1f1f4 60%, #f4f4f7)" }}>
      {/* Decorative glow blobs */}
      <div
        className="absolute top-[-160px] left-1/2 -translate-x-1/2 w-[900px] h-[560px] pointer-events-none"
        style={{ background: "radial-gradient(ellipse at center, rgba(139,92,246,0.28), transparent 62%)" }}
      />
      <div
        className="absolute top-[1100px] right-[-180px] w-[520px] h-[520px] pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(167,139,250,0.16), transparent 65%)" }}
      />
      <Navbar />
      <main className="relative">
        <Outlet />
      </main>
      <Footer />
      <FloatingTelegram />
    </div>
  );
}